angular.module('core')
  .provider('configuration', function () {
  var configuration = {

  };

  var astToStandardsWithNewLessonsMap;

  var init = function(config) {
    configuration = config;
  };

  var isDisabled = function(realm, item) {
    var itemDisableConfig = (configuration[realm] || {}).disable || {};
    if (itemDisableConfig[item] === 'true') {
      return true;
    }
    return false;
  };

  var isEnabled = function(realm, item) {
    var itemEnabledConfig = (configuration[realm] || {}).enable || {};
    if (itemEnabledConfig[item] === 'true') {
      return true;
    }
    return false;
  };

  /**
   * Return true if property is found in configuration with value equal to
   * "true" when converted to lower case.
   *
   * @param string property
   * @return boolean
   */
  var isTrue = function (property) {
    var value = _.get(configuration, property);
    return _.isString(value) && value.toLowerCase() === 'true';
  };

  var getConstant = function(name) {
    var constants = (configuration.constants || {});
    return constants[name];
  };

  var isFeatureEnabled = function(item) {
      var itemEnabledConfig = (configuration.feature || {}) || {};
      if (itemEnabledConfig[item] === 'true') {
        return true;
      }
      return false;
    };

  var isFeatureEnabledWithDefault = function(item, alt) {
    var itemEnabledConfig = (configuration.feature || {}) || {};
    if (itemEnabledConfig[item] === 'true') {
      return true;
    }

    if (itemEnabledConfig[item] === 'false') {
      return false;
    }

    return alt;
  };

  var allowedAsts = function(item) {
    var itemEnabledConfig = (configuration.allowed_asts || {}) || {};
    if (itemEnabledConfig[item]) {
      // type to array here
      return itemEnabledConfig[item].split(',');
    }
    return [];
  };

  var getPartial = function(item, type) {
    var itemConfig = (configuration[item] || {});
    var partial = (itemConfig.partials || {})[type];
    return partial;
  };

  var getIdle = function() {
    var idleConfig = (configuration.idle || {});
    return idleConfig;
  };

  var getSchoolYearStart = function() {
    var startConfig = (configuration.school_year_start || {});
    if (typeof startConfig.month === 'string') {
      startConfig.month = parseInt(startConfig.month);
    }
    if (typeof startConfig.date === 'string') {
      startConfig.date = parseInt(startConfig.date);
    }
    return startConfig;
  };

  var isExportSectionVisible = function() {
    return configuration.csv_export_enabled === 'true';
  };

  var getCategoryExceptionsList = function(providerName) {
    var list = [];
    if (configuration.analytics) {
        if(configuration.analytics[providerName]) {
            var rawList = configuration.analytics[providerName].categoryExceptionsList;
            if(rawList && rawList !== '') {
                list = rawList.split(',');
            }
        }
    }
    return list;
  };

  var injectFeatureFlags = function(scope) {
      scope.licenseSummaryEnabled =  isFeatureEnabled('license_summary_enabled');
      scope.activateStudentEnabled = isFeatureEnabled('activate_student_enabled');
  };

  var getIaplMoodleRedirectUrl = function() {
    return configuration.iapl.redirect_url;
  };

  var getIaplActivityDays = function() {
    return configuration.iapl_activities_report.days || 7;
  };

  var getConceptMapActivityDays = function() {
    return configuration.concept_map_activities_report.days || 14;
  };

  var getMoodleCourseViewPage = function() {
     return configuration.moodle.course.viewPage;
  };

  var getAstToStandardsWithNewLessonsMap = function () {
    if (astToStandardsWithNewLessonsMap) {
        return astToStandardsWithNewLessonsMap;
    }

    astToStandardsWithNewLessonsMap = {};
    var standardsByAstString = getConstant('standards_with_new_lessons');

    if (!standardsByAstString) {
        return astToStandardsWithNewLessonsMap;
    }

    var astStrings = standardsByAstString.split(';');
    var standards = _.each(astStrings, function (astString) {
        // Example: "ccss:2.G.A.1,3.G.A.1,4.G.A.2,5.G.B.3,5.G.B.4"

        var parts = astString.split(':');
        if (parts.length !== 2) {
            return;
        }

        var astName = parts[0];
        var standardsCsv = parts[1];

        if (!astName || !standardsCsv) {
            return;
        }

        astToStandardsWithNewLessonsMap[astName] = _.indexBy(standardsCsv.split(','));
    });

    return astToStandardsWithNewLessonsMap;
  };

  this.$get = function() {
    return {
      isDisabled: isDisabled,
      isEnabled: isEnabled,
      isFeatureEnabled: isFeatureEnabled,
      isFeatureEnabledWithDefault: isFeatureEnabledWithDefault,
      isTrue: isTrue,
      getPartial: getPartial,
      getIdle: getIdle,
      getSchoolYearStart: getSchoolYearStart,
      allowedAsts: allowedAsts,
      configuration: configuration,
      init: init,
      isExportSectionVisible: isExportSectionVisible,
      getConstant: getConstant,
      getAnalyticsCategoryExceptions: getCategoryExceptionsList,
      injectFeatureFlags: injectFeatureFlags,
      getIaplMoodleRedirectUrl: getIaplMoodleRedirectUrl,
      getIaplActivityDays: getIaplActivityDays,
      getConceptMapActivityDays: getConceptMapActivityDays,
      getMoodleCourseViewPage : getMoodleCourseViewPage,
      getAstToStandardsWithNewLessonsMap: getAstToStandardsWithNewLessonsMap
    };
  };

  this.isDisabled = isDisabled;
  this.isEnabled = isEnabled;
  this.isFeatureEnabled = isFeatureEnabled;
  this.isTrue = isTrue;
  this.getPartial = getPartial;
  this.getIdle = getIdle;
  this.configuration = configuration;
  this.init = init;
  this.isExportSectionVisible = isExportSectionVisible;
  this.getConstant = getConstant;
  this.getAnalyticsCategoryExceptions = getCategoryExceptionsList;
  this.injectFeatureFlags = injectFeatureFlags;
  this.getIaplMoodleRedirectUrl = getIaplMoodleRedirectUrl;
});
